import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=05074480&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=05074480&prod&lang=scss&scoped=true"
import style1 from "./Pay.vue?vue&type=style&index=1&id=05074480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05074480",
  null
  
)

export default component.exports